import {
  getAccessTokenState,
  getAuthSubscribers,
  setAccessTokenState,
} from './authStoreState.js'
import { isAuthDevBypass } from './env.js'
import { createDevAccessToken } from './devAccessToken.js'

export function getAccessToken() {
  if (isAuthDevBypass()) return createDevAccessToken()
  return getAccessTokenState()
}

export function setAccessToken(token) {
  if (token === getAccessTokenState()) return
  setAccessTokenState(token)
  for (const fn of getAuthSubscribers()) {
    try {
      fn(token)
    } catch {
      /* swallow subscriber errors so token updates never throw */
    }
  }
}

export function subscribeAuth(fn) {
  getAuthSubscribers().add(fn)
  return () => getAuthSubscribers().delete(fn)
}

export function clearAuth() {
  setAccessToken(null)
}
